export default __webpack_public_path__ + "static/media/energy.99c8d5d9.svg";